import { styled } from "@/stitches/config"

export const SAccordionHeader = styled("div", {
  position: "relative",
  zIndex: "$1",
})
